module.exports = __webpack_public_path__ + "static/media/low-fi-3.995d2792.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/gtmobile/src/low-fi-3.png
// module id = 185
// module chunks = 0